/**
 * Hoofdmenu Trajecten — API-client voor professionals, verslagen en salaris-doorzending.
 * Backend: src/routes/employerTrajecten.ts
 */
import api from './api';

const d = <T,>(r: { data: { data: T } }) => r.data.data;
const BASE = '/employer/trajecten';

export interface ContractAfspraak {
  id: string;
  functie: string | null;
  functie_label: string | null;
  uurtarief: number | null;
  korting_pct: number | null;
  effectief_uurtarief: number | null;
  max_gesprekken_per_traject: number | null;
  verslag_frequentie: string | null;
  aanvullende_afspraken: string | null;
  akkoord_professional: boolean;
  akkoord_opdrachtgever: boolean;
  akkoord_op: string | null;
}
export interface LopendDossier {
  id: string;
  /** MDW-xxxxx-X — de opdrachtgever ziet nooit een naam */
  registratienummer: string;
  discipline: string | null;
  status: string;
  start_datum: string | null;
  gesprekken: number;
  max_gesprekken: number | null;
}
export interface GecontracteerdeProfessional {
  connection_id: string;
  professional_id: string;
  naam: string;
  connected_at: string | null;
  reviews: { aantal: number; zichtbaar: boolean; gemiddelde: number | null; nog_nodig: number; drempel: number };
  afspraken: ContractAfspraak[];
  lopende_dossiers: LopendDossier[];
}
export const getGecontracteerdeProfessionals = () => api.get<{ data: GecontracteerdeProfessional[] }>(`${BASE}/professionals`).then(d);

export interface ProfessionalReviews {
  zichtbaar: boolean;
  nog_nodig: number;
  reviews: Array<{ id: string; periode: string | null; score: number; toelichting: string | null; discipline: string | null }>;
}
export const getProfessionalReviews = (professionalId: string) =>
  api.get<{ data: ProfessionalReviews }>(`${BASE}/professionals/${professionalId}/reviews`).then(d);

/** Detailscherm van één dossier: de enige plek mét cliëntnaam (lijsten tonen alleen het registratienummer). */
export interface DossierDetail {
  id: string;
  registratienummer: string;
  client_name: string;
  client_address: string | null;
  client_email: string | null;
  client_phone: string | null;
  description: string | null;
  status: string;
  professional_id: string;
  discipline: string | null;
}
export const getDossierDetail = (dossierId: string) =>
  api.get<{ data: DossierDetail }>(`${BASE}/dossiers/${dossierId}`).then(d);

export interface AnoniemGespreksverslag {
  id: string;
  dossier_id: string;
  registratienummer: string;
  professional_id: string;
  professional_naam: string;
  discipline: string | null;
  datum: string;
  session_number: string | null;
  type: string | null;
  dossier_status: string;
}
export const getGespreksverslagen = (params: { professional_id?: string; registratienummer?: string; include_closed?: boolean }) =>
  api.get<{ data: AnoniemGespreksverslag[] }>(`${BASE}/gespreksverslagen`, { params }).then(d);

export interface SalarisStatus {
  salaris_email: string | null;
  doorzendingen: Record<string, { email: string; verzonden_at: string }>;
}
export const getSalarisStatus = () => api.get<{ data: SalarisStatus }>(`${BASE}/facturen/salaris`).then(d);
export const stuurFactuurNaarSalaris = (invoiceId: string) =>
  api.post<{ data: { email: string } }>(`${BASE}/facturen/${invoiceId}/salaris`).then(d);
